type UrlSearchParamsInput = {
    refundStatusParameter?: number;
    refundIdParameter?: string | null;
    orderNumberParameter?: string | null;
    createdDateParameter?: string | null;
    endDateParameter?: string | null;
};

type UrlSearchParamsSetters = {
    setRefundStatusId: (value: number) => void;
    setRefundId: (value: string) => void;
    setOrderNumber: (value: string) => void;
    setCreatedDate: (value: string) => void;
    setEndDate: (value: string) => void;
};

export const hasRefundUrlSearchParams = (params: UrlSearchParamsInput) =>
    Boolean(
        params.refundIdParameter ||
            params.orderNumberParameter ||
            params.createdDateParameter ||
            params.endDateParameter ||
            params.refundStatusParameter
    );

export const applyRefundUrlSearchParams = (
    params: UrlSearchParamsInput,
    setters: UrlSearchParamsSetters
): Record<string, any> => {
    const req: Record<string, any> = {};

    if (params.refundStatusParameter) {
        req.RefundStatus = params.refundStatusParameter;
        setters.setRefundStatusId(Number(params.refundStatusParameter));
    }
    if (params.refundIdParameter) {
        req.refundId = params.refundIdParameter;
        setters.setRefundId(params.refundIdParameter);
    } else if (params.orderNumberParameter) {
        req.orderNumber = params.orderNumberParameter;
        setters.setOrderNumber(params.orderNumberParameter);
    } else if (params.createdDateParameter) {
        req.StartDate = params.createdDateParameter;
        setters.setCreatedDate(params.createdDateParameter);
    }
    if (params.endDateParameter) {
        req.EndDate = params.endDateParameter;
        setters.setEndDate(params.endDateParameter);
    }

    return req;
};
